<div class="location-map-picker" data-cy="location-map-picker">
  <div class="location-map-picker-row">
    <span class="location-map-picker-label-wrapper">
      <label class="location-map-picker-label" for="location-map-search">Map Location</label>
      <i
        pTooltip="The place on the map where the Location is. Search for its address, pick the matching result, and drag the pin to adjust it."
        tooltipPosition="top"
        class="pi pi-question-circle help-icon"
      ></i>
    </span>
    <span class="location-map-picker-status" data-cy="location-coordinates">{{
      hasCoordinates ? 'Set' : 'Not set'
    }}</span>
  </div>

  <div *ngIf="mode !== 'view'" class="location-map-picker-editor">
    <div class="location-map-picker-search">
      <div class="p-inputgroup">
        <input
          id="location-map-search"
          pInputText
          type="search"
          autocomplete="off"
          placeholder="Search for a US address"
          [(ngModel)]="query"
          (keydown.enter)="search()"
          data-cy="location-map-search"
        />
        <button
          pButton
          type="button"
          icon="pi pi-search"
          label="Search"
          [loading]="isSearching"
          [disabled]="!query.trim()"
          (click)="search()"
          data-cy="location-map-search-button"
        ></button>
      </div>

      <div
        *ngIf="isSearching; else searchOutcome"
        class="location-map-results"
        role="status"
        aria-label="Searching for the address"
        data-cy="location-map-results-loading"
      >
        <div *ngFor="let row of skeletonRows" class="location-map-result-skeleton">
          <p-skeleton [width]="row.LabelWidth" height="1rem"></p-skeleton>
          <p-skeleton [width]="row.DescriptionWidth" height="0.8rem"></p-skeleton>
        </div>
      </div>

      <ng-template #searchOutcome>
        <small
          *ngIf="pinnedResultId !== null"
          class="location-map-picker-message"
          data-cy="location-map-pinned-message"
        >
          The best match is pinned on the map. Pick another result if it isn't the right place.
        </small>

        <ul *ngIf="results?.length" class="location-map-results" data-cy="location-map-results">
          <li *ngFor="let result of results">
            <button
              type="button"
              [class.is-pinned]="result.Id === pinnedResultId"
              [attr.aria-pressed]="result.Id === pinnedResultId"
              (click)="pick(result)"
              data-cy="location-map-result"
            >
              <span class="location-map-result-label">{{ result.Label }}</span>
              <small>{{ result.Description }}</small>
            </button>
          </li>
        </ul>

        <small
          *ngIf="searchFailed"
          class="location-map-picker-message location-map-picker-error"
          data-cy="location-map-error"
        >
          Address search is unavailable right now. Please try again in a moment.
        </small>
        <small
          *ngIf="results?.length === 0 && !searchFailed"
          class="location-map-picker-message"
          data-cy="location-map-no-results"
        >
          No matching US addresses found. Try adding the city and state.
        </small>
        <small
          *ngIf="!hasCoordinates && !results?.length"
          class="location-map-picker-message"
          data-cy="location-map-required"
        >
          Required: search for the address and pick the matching place.
        </small>
      </ng-template>
    </div>

    <!-- Leaflet owns everything inside the map container, so the loading skeleton sits beside it. -->
    <div class="location-map-frame">
      <div #mapContainer class="location-map" data-cy="location-map"></div>
      <div *ngIf="isLocating" class="location-map-loading" aria-hidden="true" data-cy="location-map-loading">
        <p-skeleton width="100%" height="100%" borderRadius="5px"></p-skeleton>
        <i class="pi pi-map-marker"></i>
      </div>
    </div>
  </div>
</div>
